import { render, staticRenderFns } from "./LogisticsStatus.vue?vue&type=template&id=57f7dd4d&scoped=true"
import script from "./LogisticsStatus.vue?vue&type=script&lang=js"
export * from "./LogisticsStatus.vue?vue&type=script&lang=js"
import style0 from "./LogisticsStatus.vue?vue&type=style&index=0&id=57f7dd4d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f7dd4d",
  null
  
)

export default component.exports